import { render, staticRenderFns } from "./View_Favorites.vue?vue&type=template&id=41114dcd&scoped=true&"
import script from "./View_Favorites.vue?vue&type=script&lang=js&"
export * from "./View_Favorites.vue?vue&type=script&lang=js&"
import style0 from "./View_Favorites.vue?vue&type=style&index=0&id=41114dcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41114dcd",
  null
  
)

export default component.exports